import React, { useState } from "react";
import FormFilling from "./FurnishHome/FormFilling";
import GeneratedResults from "./FurnishHome/GeneratedResults";
import {
  uploadFurnishHomeImage,
  generateFurnishedImage,
} from "../api/businesses";

const FurnishHome: React.FC = () => {
  const [isProcessing, setIsProcessing] = useState(false);
  const [showResult, setShowResult] = useState(false);
  const [generatedImages, setGeneratedImages] = useState<any[]>([]);

  const handleProcessPhoto = async (
    roomType: string,
    furnitureStyle: string,
    images: File[]
  ) => {
    setIsProcessing(true);
    setGeneratedImages([]);

    try {
      const generatedImagesList = [];

      for (const image of images) {
        const fileReader = new FileReader();
        const fileBuffer = await new Promise<string>((resolve) => {
          fileReader.onload = () => resolve(fileReader.result as string);
          fileReader.readAsDataURL(image);
        });

        const fileExtension = image.name.split(".").pop() || "jpg";
        const uploadResponse = await uploadFurnishHomeImage({
          fileBuffer: fileBuffer.split(",")[1],
          fileExtension,
        });

        const { documentId, beforeUrl } = uploadResponse.data;

        const generateResponse = await generateFurnishedImage({
          image_url: beforeUrl,
          room_type: roomType,
          style: furnitureStyle,
          documentId,
        });

        const { result_image_url, render_id } = generateResponse.data;

        generatedImagesList.push({
          beforeUrl,
          afterUrl: result_image_url,
          render_id,
          documentId,
          style: furnitureStyle,
          room_type: roomType,
        });
      }

      setGeneratedImages(generatedImagesList);
      setShowResult(true);
    } catch (error) {
      console.error("Error processing images:", error);
      alert("Something went wrong while processing the images.");
    } finally {
      setIsProcessing(false);
    }
  };

  const handleGenerateNew = () => {
    setShowResult(false);
    setGeneratedImages([]);
  };

  return (
    <div className="p-6 flex flex-col items-center h-screen justify-center">
      {showResult ? (
        <GeneratedResults
          generatedImages={generatedImages}
          onGenerateNew={handleGenerateNew}
        />
      ) : (
        <FormFilling
          onProcessPhoto={handleProcessPhoto}
          isProcessing={isProcessing}
        />
      )}
    </div>
  );
};

export default FurnishHome;
